import { createContext, useReducer } from "react";


export const AllStates = createContext();


const reducer = (state, action) => {
  switch (action.type) {
    case "add":
      return { ...state, ...action.payload };

    case "remove":
      let temp = {};
      Object.keys(state).forEach((s) => {
        if (s !== action.payload) {
          temp[s] = state[s];
        }
      });
      return temp;

    case "update_contact": {
      const { key, id, updatedData } = action.payload;
      const list = state[key]?.data || [];
      const updatedList = list.map(item =>
        item.id === id ? { ...item, ...updatedData } : item
      );
      return {
        ...state,
        [key]: {
          ...state[key],
          data: updatedList
        }
      };
    }

    case "delete_contact": {
      const { key, id } = action.payload;
      const list = state[key]?.data || [];
      const updatedList = list.filter(item => item.id !== id);
      return {
        ...state,
        [key]: {
          ...state[key],
          data: updatedList,
          total: (state[key]?.total || 1) - 1
        }
      };
    }

    case "add_contact": {
      const { key, newContact } = action.payload;
      const list = state[key]?.data || [];
      const updatedList = [newContact, ...list]; // or push at end
      return {
        ...state,
        [key]: {
          ...state[key],
          data: updatedList,
          total: (state[key]?.total || 0) + 1
        }
      };
    }

    default:
      return state;
  }
};


export const AllStateProviders = ({children}) => {
    const [allState, allStatedispatch] = useReducer(reducer, {});

    return (
        <AllStates.Provider value={{allState, allStatedispatch}}>
            {children}
        </AllStates.Provider>
    )
}



// const { allState, allStatedispatch } = useContext(AllStates);

//  allStatedispatch({
//       type: "add",
//       payload: { donor: res?.data || [] },
//  });